import { formatDate } from '@angular/common';
import { AfterViewChecked, Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbDatepicker, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AppSettings } from 'src/app/app-settings';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { EventosService } from 'src/app/services/eventos.service';
import { NominativeService } from 'src/app/services/nominative.service';
import { ShoppingCartService } from 'src/app/services/shopping-cart.service';
import { TicketsService } from 'src/app/services/tickets.service';
import Swiper, { SwiperOptions } from 'swiper';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';
import { LoginComponent } from '../../shared/login/login.component';
import { SeatsPanelComponent } from '../seats-panel/seats-panel.component';
import { fixedPassTicket, isFixedPricePass } from 'src/app/utils/fixed-price-pass.util';

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day < two.day : one.month < two.month : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two ? false : one.year === two.year ? one.month === two.month ? one.day === two.day
    ? false : one.day > two.day : one.month > two.month : one.year > two.year;

@Component({
  selector: 'app-hours-dates-event',
  templateUrl: './hours-dates-event.component.html',
  styleUrls: ['./hours-dates-event.component.scss']
})
export class HoursDatesEventComponent implements OnInit, OnChanges, AfterViewChecked {

  optionsDates: any[] = [];
  optionsHours: any[] = [];
  optionsTickets: any[] = [];
  enabledTickets: any[] = [];
  selectTickets: any[] = [];

  selectedDate!: NgbDateStruct;
  numDaySelect!: number;
  dateDaySelect!: number;
  hourSelected!: any;
  priceTotal: number = 0.0;

  // Calendar
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  currentMonth!: any;
  currentYear!: any;
  dateString: any;
  hoveredDate!: any;

  fromDate!: any;
  monthsOptions: any[] = [];
  swiperMonthsConfig: SwiperOptions = {
    slidesPerView: 3,
    spaceBetween: 12,
    navigation: {
      nextEl: '.button-next-custom',
      prevEl: '.button-prev-custom',
      enabled: true
    }
  };
  @Optional() @Input() event!: any;
  /** Sesión con la que abrir ya seleccionada (una fecha del encabezado de la ficha) */
  @Input() preselectedSession: any = null;
  /**
   * Sin calendario: el componente va oculto y solo abre el mapa de la sesión
   * preseleccionada. Lo usa la ficha en los eventos de una única sesión, donde
   * no hay nada que elegir antes del mapa; se hace aquí y no en la tarjeta
   * para que decidan las mismas reglas de venta que aplica el calendario.
   */
  @Input() mapOnly: boolean = false;
  /** Solo con mapOnly: el mapa se ha abierto, se ha cerrado o no se ha podido abrir */
  @Output() mapOnlyState: EventEmitter<'opened' | 'closed' | 'unavailable'> = new EventEmitter();
  @Output() closeHours: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('dp') datepicker!: NgbDatepicker;
  fechasEvent!: any;
  now = new Date();
  buysBuySelect: any[] = [];

  enableAbono: boolean = false;
  @Input() pastEvent: boolean = false;
  @Input() organizer: boolean = false;
  openingSeats: boolean = false;
  totemActive: boolean = AppSettings.ENV_TOTEM;
  // Solo se usa en el tótem (ver openSeatPanel).
  totemOpeningSeats: boolean = false;
  fromAbono: boolean = false;
  // Abono desde el que se abre (tótem): en uno de precio fijo solo se ofrece su entrada
  abono: any = null;
  sessionSelectionOnly: boolean = false;
  private _initialized: boolean = false;

  countBoughtTickets: number = 0;
  bondEnabled: boolean = false;
  error: string = "";

  isSelectorOpen = false;
  sessionSelected: any;

  soldOut: boolean = false;
  private _pendingHourSelectionFix = false;
  availableCapacity: number = null;
  addingToCart: boolean = false;
  private errorTimeout: any;

  /**
   * Evento con entradas nominativas: la entrada se emite a nombre del comprador
   * y en el acceso le pedirán su documento identificativo.
   */
  get isNominative(): boolean {
    return this.nominativeService.isNominative(this.event);
  }

  /**
   * Tope de entradas por persona en la sesión seleccionada, o null si no hay.
   *
   * Espejo de PurchaseLimitService::effectiveLimit en el backend: el más
   * restrictivo entre el 1 que imponen las entradas nominativas y el tope que
   * haya configurado el gestor en la sesión.
   *
   * Es solo ayuda visual: desde aquí no se ven las entradas que el usuario ya
   * compró en pedidos anteriores, y por eso quien manda es el servidor.
   */
  get userTicketLimit(): number | null {
    const limits: number[] = [];

    if (this.isNominative) {
      limits.push(1);
    }

    // El tope del gestor se guarda en el evento; los eventos del editor antiguo lo
    // tienen además en la sesión. Igual que en el backend, mandan los dos y gana el
    // más restrictivo.
    const perEvent = this.event?.max_tickets_per_order;
    if (perEvent !== null && perEvent !== undefined && +perEvent > 0) {
      limits.push(+perEvent);
    }

    const perUser = this.sessionSelected?.max_tickets_per_user;
    if (perUser !== null && perUser !== undefined && +perUser > 0) {
      limits.push(+perUser);
    }

    return limits.length > 0 ? Math.min(...limits) : null;
  }

  /**
   * Solo se puede seleccionar una entrada. Aplica al flujo de abonos, que ya lo
   * hacía, y a cualquier sesión cuyo tope por persona sea 1 (entre ellas las de
   * los eventos nominativos).
   */
  get singleTicketOnly(): boolean {
    return this.fromAbono || this.userTicketLimit === 1;
  }

  /**
   * ¿Se ha alcanzado ya el tope de entradas por persona en la selección actual?
   */
  private userLimitReached(): boolean {
    const limit = this.userTicketLimit;
    return limit !== null && this.getTotalSelectedTickets() >= limit;
  }

  constructor(private calendar: NgbCalendar, public formatter: NgbDateParserFormatter, private ticketsService: TicketsService,
    @Optional() private dialogRef: MatDialogRef<HoursDatesEventComponent>, private dialog: MatDialog, private auth: AuthenticationService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data, private router: Router, private shoppingCartService: ShoppingCartService,
    private eventosService: EventosService, private nominativeService: NominativeService) {
  }

  ngOnInit(): void {
    if (this.data) {
      this.event = this.data.event;
      this.organizer = this.data.organizer;
      this.fromAbono = this.data.fromAbono || false;
      this.abono = this.data.abono || null;
      this.sessionSelectionOnly = this.data.sessionSelectionOnly || false;
    }
    let now = new Date();
    now.setHours(0);
    now.setMinutes(0);

    // NO filtrar las sesiones aquí - ya vienen filtradas desde info-abonos.component
    // Solo ordenarlas por fecha
    this.fechasEvent = this.event.sessions.sort((a, b) => new Date(a.start_date).getTime() - new Date(b.start_date).getTime());

    if (this.fechasEvent.length === 0) {
      console.error('No hay sesiones disponibles');
      return;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayStr = formatDate(today, 'yyyy-MM-dd', 'es');

    // Parsear fechas sin conversión de zona horaria
    const parseDateWithoutTimezone = (dateStr: string) => {
      if (!dateStr || typeof dateStr !== 'string') {
        return new Date();
      }
      const datePart = dateStr.replace(' ', 'T').split('T')[0];
      const [year, month, day] = datePart.split('-').map(Number);
      if (isNaN(year) || isNaN(month) || isNaN(day)) {
        return new Date();
      }
      return new Date(year, month - 1, day);
    };

    // Regla que prima: sesión visible hasta sesión+1h (y si hay end_sales, también hasta end_sales+1h).
    // Incluir un día si tiene al menos una sesión "disponible" según esta regla.
    const dateStringsWithAvailableSession = new Set<string>();
    this.fechasEvent.forEach((fecha: any) => {
      if (!fecha.start_date) return;
      if (fecha.active === false) return;
      if (!this.isSessionStillAvailableForCalendar(fecha, todayStr)) return;
      const dateStr = String(fecha.start_date).replace(' ', 'T').split('T')[0];
      const [year, month, day] = dateStr.split('-').map(Number);
      if (isNaN(year) || isNaN(month) || isNaN(day)) return;
      const dateLocal = new Date(year, month - 1, day);
      dateStringsWithAvailableSession.add(dateLocal.toDateString());
    });

    this.optionsDates = Array.from(dateStringsWithAvailableSession).sort(
      (a, b) => new Date(a).getTime() - new Date(b).getTime()
    );

    let first = this.fechasEvent[0];
    let last = this.fechasEvent[this.fechasEvent.length - 1];

    // Primer día que aún tiene alguna sesión disponible (según sesión+1h / end_sales+1h)
    const firstFutureSession = this.fechasEvent.find((session: any) =>
      session.start_date && this.isSessionStillAvailableForCalendar(session, todayStr)
    ) || first;

    const firstSessionDate = parseDateWithoutTimezone(firstFutureSession.start_date);
    const start = firstSessionDate;

    // La fecha máxima es la última sesión (usar end_date si existe, sino start_date)
    const lastSessionEndDate = last.end_date ? parseDateWithoutTimezone(last.end_date) : parseDateWithoutTimezone(last.start_date);
    const end = lastSessionEndDate;

    this.currentMonth = start.getMonth() + 1;
    this.currentYear = start.getFullYear();
    this.minDate = new NgbDate(start.getFullYear(), start.getMonth() + 1, start.getDate());
    this.maxDate = new NgbDate(end.getFullYear(), end.getMonth() + 1, end.getDate());
    this.getMonths();

    if (!this.event.informative || !this.event.external) {

      //Obtener todas las fechas disponibles
      this.optionsHours = [];
      this.fechasEvent.forEach(session => {
        // Verificar que la sesión tenga start_date válido
        if (!session.start_date || typeof session.start_date !== 'string') {
          console.warn('Sesión sin start_date válido:', session);
          return;
        }

        // Parsear la fecha preservando el día exacto
        // Manejar formato con 'T' o con espacio
        const normalizedDate = session.start_date.replace(' ', 'T');
        const dateTimeParts = normalizedDate.split('T');
        const datePart = dateTimeParts[0]; // YYYY-MM-DD
        const timePart = dateTimeParts[1] || '00:00:00'; // HH:mm:ss o default

        const [year, month, day] = datePart.split('-').map(Number);
        const [hours, minutes] = timePart.split(':').map(Number);

        // Validar que los valores sean números válidos
        if (isNaN(year) || isNaN(month) || isNaN(day) || isNaN(hours) || isNaN(minutes)) {
          console.warn('Fecha con formato inválido:', session.start_date);
          return;
        }

        const date = new Date(year, month - 1, day, hours, minutes);

        const dateString = formatDate(date, 'yyyy-MM-dd', 'es');
        const timeKey = formatDate(date, 'HH:mm', 'es');
        const optionExist = this.optionsHours.find(option => option.time == timeKey)
        if (!optionExist) {
          this.optionsHours.push({ time: timeKey, sessions: [dateString], dates: [session.start_date] });
        } else {
          optionExist.sessions.push(dateString);
          optionExist.dates.push(session.start_date);
        }
      });

      // Ordenar horas de menor a mayor (07:25, 10:00, 12:00...)
      this.optionsHours.sort((a, b) => {
        const [ha, ma] = a.time.split(':').map(Number);
        const [hb, mb] = b.time.split(':').map(Number);
        return (ha * 60 + (ma || 0)) - (hb * 60 + (mb || 0));
      });

      // Entradas disponibles
      this.optionsTickets = this.event.tickets.filter(ticket => ticket.active == true);
    }

    // Verificar que hay fechas válidas disponibles
    if (this.optionsDates.length === 0) {
      this.emitMapOnly('unavailable');
      return;
    }

    // Fechas disponibles
    if (this.optionsDates.length > 0) {
      // Convertir el toDateString al formato yyyy-MM-dd que usamos en optionsHours
      const firstDateObj = new Date(this.optionsDates[0]);
      this.dateString = formatDate(firstDateObj, 'yyyy-MM-dd', 'es');
      this.fromDate = new NgbDate(firstDateObj.getFullYear(), firstDateObj.getMonth() + 1, firstDateObj.getDate());
    }

    // Si hay una sesión preseleccionada, establecerla. En el diálogo llega por
    // data; en el panel de escritorio, por el input.
    const preselectedSession = this.data?.preselectedSession || this.preselectedSession;
    if (preselectedSession) {
      this.applyPreselectedSession(preselectedSession);
    } else {
      // Buscar la primera sesión disponible (según regla sesión+1h / end_sales+1h) y que esté activa
      const nextAvailableSession = this.fechasEvent.find(session =>
        session.start_date && session.active !== false && this.isSessionStillAvailableForCalendar(session, todayStr)
      );

      const sessionToUse = nextAvailableSession || this.fechasEvent[0];
      const dateToSelect = parseDateWithoutTimezone(sessionToUse.start_date);

      let initNgb = new NgbDate(dateToSelect.getFullYear(), dateToSelect.getMonth() + 1, dateToSelect.getDate())
      this.changeDateSelected(initNgb, true);
      this.selectedDate = initNgb;
      // const hourOption = this.optionsHours.find(option => option.dates.includes(nextAvailableSession.start_date));
      // if (hourOption) {
      //   this.changeHour(hourOption);
      // }

    }

    if (this.mapOnly) {
      // La hora puede haber quedado puesta y aun así estar fuera de venta (hoy,
      // pasado el corte): el calendario la retira un tick después, así que se
      // comprueba aquí antes de abrir nada.
      const canSell = this.sessionSelected && this.hourSelected
        && !this.shouldHideHourChipForTime(this.hourSelected, this.dateString);
      if (canSell) {
        this.openSeatPanel();
      } else {
        this.emitMapOnly('unavailable');
      }
    }

    // Navegar el datepicker al mes correcto después de la inicialización
    setTimeout(() => {
      if (this.datepicker && this.selectedDate) {
        this.navigateToSelectedMonth();
      } else if (this.datepicker && this.minDate) {
        this.datepicker.navigateTo({ year: this.minDate.year, month: this.minDate.month });
      }
      this._initialized = true;
    }, 0);
  }

  /**
   * Con el panel ya abierto en escritorio, pulsar otra fecha del encabezado
   * no vuelve a crear el componente: llega como cambio del input y hay que
   * saltar a esa fecha aquí.
   */
  ngOnChanges(changes: SimpleChanges): void {
    const change = changes.preselectedSession;
    if (!change || change.firstChange || !this._initialized || !this.preselectedSession) {
      return;
    }
    this.applyPreselectedSession(this.preselectedSession);
    this.navigateToSelectedMonth();
  }

  /** Deja seleccionados el día y la hora de una sesión concreta */
  private applyPreselectedSession(preselectedSession: any): void {
    const datePart = String(preselectedSession.start_date).replace(' ', 'T').split('T')[0];
    const [year, month, day] = datePart.split('-').map(Number);

    const preselectedNgb = new NgbDate(year, month, day);
    this.changeDateSelected(preselectedNgb, true);
    this.selectedDate = preselectedNgb;

    // Encontrar y establecer la hora correspondiente
    const hourOption = this.optionsHours.find(option => option.dates.includes(preselectedSession.start_date));
    if (hourOption) {
      this.changeHour(hourOption);
    }
  }

  /** Lleva el calendario y la tira de meses al mes del día seleccionado */
  private navigateToSelectedMonth(): void {
    if (!this.datepicker || !this.selectedDate) {
      return;
    }
    this.goToMonth(this.datepicker, { year: this.selectedDate.year, month: this.selectedDate.month });
  }

  ngAfterViewChecked(): void {
    // Si la hora seleccionada ya no es visible (ej. pasó el corte sesión+1h), elegir la siguiente disponible
    if (!this.dateString || !this.hourSelected || this.optionsHours.length === 0) return;
    if (this._pendingHourSelectionFix) return;
    if (!this.shouldHideHourChipForTime(this.hourSelected, this.dateString)) return;
    this._pendingHourSelectionFix = true;
    const firstVisible = this.optionsHours.find(
      h => h.sessions.includes(this.dateString) && !this.shouldHideHourChipForTime(h, this.dateString)
    );
    if (firstVisible) {
      setTimeout(() => {
        this._pendingHourSelectionFix = false;
        this.changeHour(firstVisible);
      }, 0);
    } else {
      setTimeout(() => {
        this._pendingHourSelectionFix = false;
        this.hourSelected = null;
        this.sessionSelected = null;
        this.enabledTickets = [];
        this.selectTickets = [];
      }, 0);
    }
  }

  onSelectOpened(opened: boolean): void {
    if (opened) {

      const overlayPanes = document.querySelectorAll('.cdk-overlay-pane');
      const overlayPane = overlayPanes[overlayPanes.length - 1] as HTMLElement;
      const screen = window.innerWidth
      if (overlayPane) {
        const currentLeft = parseFloat(overlayPane.style.left.replace('px', ''));
        const currentTop = parseFloat(overlayPane.style.top.replace('px', ''));
        if (screen <= 900) {

        }
        // overlayPane.style.width = '280px';
        // overlayPane.style.top = `${currentTop + 10}px`;
        // overlayPane.style.left = `${currentLeft - 16}px`;
      }

    }
  }


  getMonths() {
    this.monthsOptions = [];

    // Empezar desde el minDate, no desde hoy
    let currentDate = new NgbDate(this.minDate.year, this.minDate.month, 1);
    const maxDate = new NgbDate(this.maxDate.year, this.maxDate.month, 1);

    // Generar todos los meses desde minDate hasta maxDate
    while (currentDate.year < maxDate.year ||
      (currentDate.year === maxDate.year && currentDate.month <= maxDate.month)) {

      this.monthsOptions.push({
        value: { month: currentDate.month, year: currentDate.year },
        string: this.formatStringDate(currentDate)
      });

      // Avanzar al siguiente mes
      if (currentDate.month === 12) {
        currentDate = new NgbDate(currentDate.year + 1, 1, 1);
      } else {
        currentDate = new NgbDate(currentDate.year, currentDate.month + 1, 1);
      }
    }
  }

  // Calendar
  isHovered(date: NgbDate) {
    return this.hoveredDate && date.before(this.hoveredDate);
  }
  isWeekend = (date: NgbDate) => this.calendar.getWeekday(date) >= 6;

  changeDateSelected(date: NgbDate, selected?: boolean) {
    if (!this.dayDisabled(date)) {
      this.soldOut = false;
      this.error = null;
      
      // Usar el mismo formato que en optionsHours para que coincidan
      const dateObj = new Date(date.year, date.month - 1, date.day);
      this.dateString = formatDate(dateObj, 'yyyy-MM-dd', 'es');
      this.selectedDate = date;
      this.numDaySelect = dateObj.getDay();
      this.dateDaySelect = dateObj.getDate();

      // Todas las horas visibles para la fecha (sin filtrar por activo)
      const visibleHoursForDate = this.optionsHours.filter(
        hour => hour.sessions.includes(this.dateString) && !this.shouldHideHourChipForTime(hour, this.dateString)
      );

      // Horas disponibles y además visibles (no ocultas por regla sesión+1h / end_sales+1h) y con sesión activa
      const availableHoursForDate = visibleHoursForDate.filter(hour => {
        const sessionDate = hour.dates?.find((d: string) => {
          if (!d || typeof d !== 'string') return false;
          const datePart = d.replace(' ', 'T').split('T')[0];
          const [y, m, dy] = datePart.split('-').map(Number);
          if (isNaN(y) || isNaN(m) || isNaN(dy)) return false;
          return formatDate(new Date(y, m - 1, dy), 'yyyy-MM-dd', 'es') === this.dateString;
        });
        const session = sessionDate ? this.fechasEvent.find((s: any) => s.start_date === sessionDate) : null;
        return !session || session.active !== false;
      });

      // Siempre autoseleccionamos la primera hora disponible y visible
      if (availableHoursForDate.length > 0) {
        this.changeHour(availableHoursForDate[0]);
      } else {
        this.hourSelected = null;
        this.sessionSelected = null;
        this.enabledTickets = [];
        this.selectTickets = [];
        this.priceTotal = 0;
        // Hay sesiones para esta fecha pero ninguna está activa
        if (visibleHoursForDate.length > 0) {
          this.error = 'Lo sentimos, no hay sesiones activas para la fecha seleccionada.';
        }
      }
    }
  }

  formatStringDate(date: any, format: string = 'MMM YYYY') {
    let dateFormat = null;
    if (date) {
      // Crear un Date object directamente desde NgbDate para evitar problemas de formato
      const dateObj = new Date(date.year, date.month - 1, date.day);
      dateFormat = formatDate(dateObj, format, 'es');
    }
    return dateFormat;
  }

  goToMonth(dp: any, date: any) {
    dp.navigateTo(date);
    this.currentMonth = date.month;
    this.currentYear = date.year;
  }

  dayDisabled(date: NgbDateStruct) {
    // Crear fecha local sin conversión de zona horaria
    const dateNew = new Date(date.year, date.month - 1, date.day);
    if (before(date, this.minDate) ||
      !this.optionsDates.includes(dateNew.toDateString()) ||
      after(date, this.maxDate)) {
      return true;
    }
    return this.isDayDisabledBecauseNoSessionsAvailable(date);
  }

  /**
   * Indica si una sesión sigue "disponible" para el calendario según la regla que prima:
   * sesión+1h (y si hay end_sales, también end_sales+1h). Así ej. el día 11 se muestra
   * mientras la hora actual sea anterior al corte (ej. sesión 06:31 → hasta 07:31).
   */
  private isSessionStillAvailableForCalendar(session: any, todayStr: string): boolean {
    if (!session?.start_date) return false;
    const normalized = String(session.start_date).replace(' ', 'T');
    const parts = normalized.split('T');
    const datePart = parts[0];
    const timePart = (parts[1] || '00:00:00').substring(0, 5);
    const sessionDateStr = datePart;
    const nowMs = Date.now();

    // Sesión ya empezada que el fin de ventas todavía permite vender. Va antes
    // del corte por días porque la sesión puede ser de ayer: a las 00:30 se
    // sigue vendiendo la de las 22:00.
    if (this.eventosService.isSessionSaleExtended(this.event, session)) return true;

    if (this.event?.end_sales) {
      const cutoffGlobalMs = new Date(this.event.end_sales).getTime() + 60 * 60 * 1000;
      if (nowMs >= cutoffGlobalMs) return false;
    }

    if (sessionDateStr < todayStr) return false;
    if (sessionDateStr > todayStr) return true;

    const [h, min] = timePart.split(':').map(Number);
    const cutoffMs = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      h + 1,
      min ?? 0,
      0,
      0
    ).getTime();
    return nowMs < cutoffMs;
  }

  /**
   * Deshabilita el día cuando es "hoy" y ya no queda ninguna sesión disponible
   * (todas han pasado su sesión+1h, o se ha pasado end_sales+1h).
   */
  private isDayDisabledBecauseNoSessionsAvailable(date: NgbDateStruct): boolean {
    const today = new Date();
    const todayStr = formatDate(today, 'yyyy-MM-dd', 'es');
    const dateStr = `${date.year}-${String(date.month).padStart(2, '0')}-${String(date.day).padStart(2, '0')}`;
    if (dateStr !== todayStr) {
      return false;
    }
    const nowMs = Date.now();
    if (this.event?.end_sales) {
      const cutoffGlobalMs = new Date(this.event.end_sales).getTime() + 60 * 60 * 1000;
      if (nowMs >= cutoffGlobalMs) {
        return true;
      }
    }
    const sessionsOnThisDay = (this.fechasEvent || []).filter((session: any) => {
      if (!session?.start_date) return false;
      const normalized = String(session.start_date).replace(' ', 'T');
      const datePart = normalized.split('T')[0];
      const [y, m, d] = datePart.split('-').map(Number);
      return y === date.year && m === date.month && d === date.day;
    });
    if (sessionsOnThisDay.length === 0) {
      return false;
    }
    let latestCutoffMs = 0;
    for (const session of sessionsOnThisDay) {
      // Sesión empezada que el fin de ventas todavía permite vender: el día
      // sigue habilitado.
      if (this.eventosService.isSessionSaleExtended(this.event, session)) {
        return false;
      }
      const normalized = String(session.start_date).replace(' ', 'T');
      const parts = normalized.split('T');
      const timePart = (parts[1] || '00:00:00').substring(0, 5);
      const [h, min] = timePart.split(':').map(Number);
      const cutoff = new Date(date.year, date.month - 1, date.day, h + 1, min ?? 0, 0, 0);
      latestCutoffMs = Math.max(latestCutoffMs, cutoff.getTime());
    }
    return nowMs >= latestCutoffMs;
  }

  isActive(date: NgbDateStruct, dateNew: Date) {
    if (this.fechasEvent.typeRepeat == 'week' && this.fechasEvent.repeatInterval.includes(dateNew.getDay())) {
      return true;
    }
    if (this.fechasEvent.typeRepeat == 'month' && this.fechasEvent.repeatInterval.includes(date.day)) {
      return true;
    }
    if (this.fechasEvent.typeRepeat == 'year' && date.day == this.minDate.day && date.month == this.minDate.month) {
      return true;
    }
    return false;
  }

  // Horarios
  onHourChipClick(hour: any) {
    // Buscar la sesión correspondiente al día y hora seleccionados para comprobar si está activa
    const optionSession = hour.dates?.find((session: any) => {
      if (!session || typeof session !== 'string') return false;
      const normalizedDate = session.replace(' ', 'T');
      const datePart = normalizedDate.split('T')[0];
      const [year, month, day] = datePart.split('-').map(Number);
      if (isNaN(year) || isNaN(month) || isNaN(day)) return false;
      const dateLocal = new Date(year, month - 1, day);
      return formatDate(dateLocal, 'yyyy-MM-dd', 'es') == this.formatStringDate(this.selectedDate, 'yyyy-MM-dd');
    });
    const session = optionSession ? this.fechasEvent.find((s: any) => s.start_date == optionSession) : null;
    if (session && session.active === false) {
      this.openInfoCard('Esta sesión no está activa en este momento.');
      return;
    }
    this.changeHour(hour);
  }

  changeHour(hour: any) {
    if (!this.selectedDate) {
      this.openInfoCard('Primero debes seleccionar un día en el calendario');
      return;
    }

    this.hourSelected = hour;
    this.soldOut = false;
    this.error = null;

    // Verificar que hourSelected tiene dates
    if (!this.hourSelected || !this.hourSelected.dates) {
      console.error('hourSelected no tiene dates:', this.hourSelected);
      return;
    }

    // Coger la sesion con el dia y la hora seleccionados
    const optionSession = this.hourSelected.dates.find(session => {
      // Validar que session es válido
      if (!session || typeof session !== 'string') return false;

      // Parsear la fecha preservando el día exacto
      // Manejar formato con 'T' o con espacio
      const normalizedDate = session.replace(' ', 'T');
      const dateTimeParts = normalizedDate.split('T');
      const datePart = dateTimeParts[0];
      const [year, month, day] = datePart.split('-').map(Number);

      // Validar que los valores sean números válidos
      if (isNaN(year) || isNaN(month) || isNaN(day)) return false;

      const dateLocal = new Date(year, month - 1, day);
      return formatDate(dateLocal, 'yyyy-MM-dd', 'es') == this.formatStringDate(this.selectedDate, 'yyyy-MM-dd');
    });
    this.sessionSelected = this.fechasEvent.find((sesion: any) => sesion.start_date == optionSession);

    // Si solo estamos seleccionando sesión (modo abono), cerrar con la sesión seleccionada
    // Solo cerrar si ya se completó la inicialización (evitar cierre automático durante init)
    if (this.sessionSelectionOnly && this._initialized && this.selectedDate && this.sessionSelected) {
      this.dialogRef.close({
        session: this.sessionSelected
      });
      return;
    }

    if (this.selectedDate && this.sessionSelected) {
      this.getTicketsEnabled();
    }
  }

  openSelect(fromSelect: boolean = false) {
    if (this.optionsDates.length === 0) {
      this.openInfoCard('Este evento no tiene sesiones activas disponibles en este momento.');
      return;
    }
    this.isSelectorOpen = !this.isSelectorOpen;
    if (!this.selectedDate) {
      this.openInfoCard('Por favor, selecciona un día en el calendario')
    } else if (this.selectedDate && (this.optionsHours.length > 0 && !this.hourSelected)) {
      this.openInfoCard('Por favor, selecciona un horario')
    } else if (!fromSelect && this.optionsTickets.length > 0 && this.selectTickets.length <= 0) {
      this.openInfoCard('Por favor, selecciona una entrada')
    }
  }

  getTicketsEnabled() {
    this.enabledTickets = [];
    this.selectTickets = [];
    this.priceTotal = 0;
    this.ticketsService.getTicketsBySession(this.sessionSelected.id).subscribe({
      next: (res: any) => {
        // El backend ya devuelve las entradas ordenadas por precio ascendente
        this.enabledTickets = res.data.filter((t: any) => t.active);
        // Abono de precio fijo: una sola entrada, la del abono, a su precio (la general la pone el back)
        if (this.fromAbono && isFixedPricePass(this.abono)) {
          const passTicket = fixedPassTicket(this.abono, this.sessionSelected.id, null);
          this.enabledTickets = passTicket ? [passTicket] : [];
        }
        this.eventosService.getInfoCapacityEvent(this.sessionSelected.id).subscribe({
          next: (resCount: any) => {
            if(resCount.capacity && resCount.capacity <= resCount.sold) {
              this.soldOut = true;
              this.availableCapacity = 0;
              this.error = "Lo sentimos, no hay entradas disponibles para el día y la hora seleccionadas.";
            } else {
              this.soldOut = false;
              if (!this.errorTimeout) this.error = null;
              this.availableCapacity = resCount.capacity ? resCount.capacity - (resCount.sold || 0) : null;
            }
          }, error: (err) => {
            this.soldOut = false;
            if (!this.errorTimeout) this.error = null;
            this.availableCapacity = null;
          }
        });
      }
    });
  }

  getTotalSelectedTickets(): number {
    return this.selectTickets.reduce((total, item) => total + item.number, 0);
  }

  // Ticket option
  addTicketOption(option: any) {
    if (this.isSelectorOpen) this.isSelectorOpen = false;

    // Abonos: solo 1 entrada por sesión
    if (this.fromAbono && this.selectTickets.length > 0) {
      return;
    }

    // Tope de entradas por persona (nominativas o tope del gestor)
    if (this.userLimitReached()) {
      const limit = this.userTicketLimit;
      const msg = limit === 1
        ? 'Solo se permite 1 entrada por persona en esta sesión.'
        : `Solo se permiten ${limit} entradas por persona en esta sesión.`;
      this.showTemporaryError(msg);
      this.openInfoCard(msg);
      return;
    }

    if (this.availableCapacity !== null && this.getTotalSelectedTickets() >= this.availableCapacity) {
      const msg = `Solo hay ${this.availableCapacity} entradas disponibles para esta sesión.`;
      this.showTemporaryError(msg);
      this.openInfoCard(msg);
      return;
    }

    const index = this.selectTickets.findIndex(value => value.ticket.id == option.id);
    if (index == -1) {
      let price = +option.price;
      this.priceTotal += +price;
      this.selectTickets.push({ ticket: option, number: 1 });
    } else {
      this.selectTickets[index].number++;
      let price = +option.price;
      this.priceTotal += +price;
    }
  }

  changeTypeTicket(option: any, typeAction: any) {
    const index = this.selectTickets.findIndex(value => value.ticket.id == option.ticket.id);
    if (index != -1) {
      const element = this.selectTickets[index];
      const ticketsMax = element.ticket.max_tickets || this.event.maxTickets;
      let price = element.ticket.price;
      if (typeAction == 'delete') {
        option.number--;
        this.priceTotal -= +price;
      }
      if (typeAction != 'delete') {
        // Con una sola entrada permitida no hay nada que incrementar
        if (this.singleTicketOnly) {
          return;
        }
        if (this.userLimitReached()) {
          const limit = this.userTicketLimit;
          const msg = `Solo se permiten ${limit} entradas por persona en esta sesión.`;
          this.showTemporaryError(msg);
          this.openInfoCard(msg);
          return;
        }
        if (this.availableCapacity !== null && this.getTotalSelectedTickets() >= this.availableCapacity) {
          const msg = `Solo hay ${this.availableCapacity} entradas disponibles para esta sesión.`;
          this.showTemporaryError(msg);
          this.openInfoCard(msg);
          return;
        }
        if (!ticketsMax || ticketsMax > option.number) {
          option.number++;
          this.priceTotal += +price;
        }
      }
      if (option.number == 0 && typeAction == 'delete') {
        this.selectTickets.splice(index, 1);
      }
    }
  }

  /**
   * Avisa a la ficha de cómo va el mapa abierto sin calendario. Aplazado un
   * tick: la ficha retira este componente al recibirlo, y puede llegar desde
   * el propio ngOnInit.
   */
  private emitMapOnly(state: 'opened' | 'closed' | 'unavailable') {
    if (this.mapOnly) {
      setTimeout(() => this.mapOnlyState.emit(state), 0);
    }
  }

  /**
   * Pide login (o registro) en un diálogo y, si lo consigue, retoma la acción
   * que se quedó a medias.
   */
  private requestLogin(onLogged: () => void) {
    const dialogRef = this.dialog.open(LoginComponent, {
      panelClass: ['info-dialog', 'dialog-login'],
      data: {
        exit: false,
        seats: true
      }
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        if (res?.login) {
          onLogged();
        }
      }
    });
  }

  openSeatPanel() {
    // Candado en todos los entornos: el botón solo se "desactiva" por clase CSS y
    // `openingSeats` no se levantaba hasta que respondía getCountTicketsByEvent, así
    // que en esa ventana un segundo click lanzaba otra petición y acababa abriendo un
    // segundo mapa en blanco (fabric se engancha al id fijo #myCanvas y solo pinta en
    // el primero del DOM). En el tótem, además, el candado no se suelta hasta que se
    // cierra el mapa (pantalla táctil).
    if (this.openingSeats || this.totemOpeningSeats) return;

    if (!(this.numDaySelect == null || ((this.optionsHours.length > 0 && !this.hourSelected) || this.optionsHours.length <= 0))) {
      // El mapa se abre sin cuenta: hay que poder ver qué queda libre, los tipos
      // de entrada y los precios antes de registrarse. El login lo pide el
      // propio mapa al añadir al carrito (SeatsPanelComponent.goBuyTickets).
      // Feedback desde el primer click y no al recibir la primera respuesta: hay dos
      // peticiones por delante (aforo vendido y mapa de la sesión) y el mapa de un
      // recinto grande (Palacio de los Deportes) tarda varios segundos en llegar.
      this.openingSeats = true;
      if (this.totemActive) {
        this.totemOpeningSeats = true;
      }
      this.eventosService.getCountTicketsByEvent(this.sessionSelected.id).subscribe({
        next: (res: any) => {
          this.countBoughtTickets = res?.data?.count;
          // Comprobar si tiene mapa
          let maxCount = this.event.capacity;
          if (!maxCount && this.event.space && this.event.space.capacity) {
            maxCount = this.event.space.capacity;
          }
          if (maxCount && this.countBoughtTickets && maxCount <= this.countBoughtTickets) {
            // Informar que no hay entradas disponibles
            this.openingSeats = false;
            this.totemOpeningSeats = false;
            this.openInfoCard('Lo sentimos, no hay entradas disponibles para el día y la hora seleccionadas.');
            this.emitMapOnly('closed');
          } else {
            this.openTickets();
          }
        }, error: (err) => {
          this.openTickets();
        }
      })
    } else {
      if (this.numDaySelect == null) {
        this.openInfoCard('Por favor, selecciona un día en el calendario');
      } else if (this.optionsHours.length > 0 && !this.hourSelected) {
        this.openInfoCard('Por favor, selecciona un horario');
      }
    }
  }

  openTickets(dateTime?: any) {
    // Pedir el mapa por sesión del evento
    this.eventosService.getMapEventBySession(this.event.id, this.sessionSelected.id).subscribe({
      next: (res: any) => {
        this.openingSeats = false;
        this.emitMapOnly('opened');
        // Abrir el mapa del evento
        const dialogRef = this.dialog.open(SeatsPanelComponent, {
          panelClass: ['info-dialog', 'not-padding', 'panel-seats'],
          data: { event: this.event, session: this.sessionSelected, mapEvent: res.data, tickets: this.optionsTickets }
        });
        dialogRef.afterClosed().subscribe(res => {
          // El candado del tótem se suelta al cerrarse el mapa, no antes.
          this.totemOpeningSeats = false;
          this.emitMapOnly('closed');
          if (res && res.cart_lines?.length > 0) {
            this.router.navigate(['/cart-checkout']).then(() => {
              this.priceTotal = +res.price;
              this.selectTickets = res.tickets;
              this.dialog.closeAll();
            });
          }
        })
      }, error: (err: any) => {
        this.openingSeats = false;
        this.totemOpeningSeats = false;
        this.error = 'Lo sentimos, en este momento no es posible seleccionar asientos. Por favor, inténtalo de nuevo más tarde.';
        // Sin calendario a la vista el aviso de abajo no se vería
        if (this.mapOnly) {
          this.openInfoCard(this.error);
          this.emitMapOnly('closed');
        }
      }
    })

    return;
  }

  getDateTime() {
    const date = this.formatter.format(this.selectedDate);
    let dateAux = new Date(date);
    let time = null;
    if (this.hourSelected) {
      let init = new Date(this.hourSelected.horaInicio);
      dateAux.setUTCHours(init.getUTCHours());
      dateAux.setUTCMinutes(init.getUTCMinutes());

      time = dateAux.toISOString();
    }
    return { date: date, time: time };
  }

  openPlatformBuy() {
    // Validar que el horario es correcto
    // Validar que las entradas son correctas
    if (this.event?.preciodesde > 0 && this.priceTotal > 0) {
      this.dialogRef?.close();
      this.router.navigate(['/checkout/validate'], { state: { price: this.priceTotal, tickets: this.selectTickets, session: this.sessionSelected, eventName: this.event.title, event: this.event.id } });
    }
    if (this.event?.preciodesde <= 0 && !this.event.informativo) {
      const dialogRef = this.dialog.open(InfoCardComponent, {
        panelClass: 'info-dialog',
        data: {
          icon: false,
          text: 'Te has apuntado al evento correctamente',
          btnCancel: false
        }
      });
      dialogRef.afterClosed().subscribe(res => this.dialog.closeAll());
    }
  }

  goBuyTickets() {
    if (this.soldOut || this.addingToCart) return;

    if (this.optionsDates.length === 0) {
      this.openInfoCard('Este evento no tiene sesiones activas disponibles en este momento.');
      return;
    }

    if (!this.selectedDate || (this.optionsHours.length > 0 && !this.hourSelected) || (this.optionsTickets.length > 0 && this.selectTickets.length <= 0)) {
      this.openSelect();
    } else {
      const totalRequested = this.getTotalSelectedTickets();
      if (this.availableCapacity !== null && totalRequested > this.availableCapacity) {
        const msg = `Solo hay ${this.availableCapacity} entradas disponibles para esta sesión.`;
        this.showTemporaryError(msg);
        this.openInfoCard(msg);
        return;
      }

      this.error = null;
      let payload = {
        cart_lines: []
      };
      this.selectTickets.forEach(element => {
        payload.cart_lines.push({
          id_event: this.event.id,
          id_ticket: element.ticket.id,
          id_session: this.sessionSelected.id,
          quantity: element.number,
        });
      });

      if (this.fromAbono) {
        let totalPrice = 0;
        this.selectTickets.forEach(element => {
          totalPrice += element.ticket.price * element.number;
        });

        this.dialogRef.close({
          cart_lines: payload.cart_lines,
          price: totalPrice,
          tickets: this.selectTickets,
          session: this.sessionSelected
        });
      } else {
        let user = this.auth.getProfile();
        if (!user) {
          // En el tótem no se pide login: la compra cuelga del usuario del kiosco.
          if (AppSettings.ENV_TOTEM) {
            this.auth.ensureTotemSession().subscribe((totemUser) => {
              if (totemUser) {
                this.addToCart(payload);
              } else {
                this.dialog.open(InfoCardComponent, {
                  panelClass: 'info-dialog',
                  data: {
                    icon: true,
                    text: '¡Vaya! No se ha podido iniciar la compra. Por favor, vuelve a intentarlo.',
                    btnCancel: false
                  }
                });
              }
            });
            return;
          }
          // Sin mapa el tipo de entrada se elige en este mismo panel, así que
          // este es el primer momento en el que hace falta la cuenta.
          this.requestLogin(() => this.goBuyTickets());
          return;
        }
        if (user) {
          // Eventos nominativos: confirmar el titular antes de añadir al
          // carrito. El dato se guarda en el perfil y desde ahí lo congela el
          // backend en las entradas al generar el pedido.
          this.nominativeService.ensureHolderData(this.event).subscribe((canContinue) => {
            if (canContinue) {
              this.addToCart(payload);
            }
          });
        }
      }
    }
  }

  addToCart(payload: any) {
    this.addingToCart = true;
    this.shoppingCartService.addToCart(payload).subscribe({
      next: (res) => {
        this.addingToCart = false;
        if (res && res.success === false) {
          this.handleCartError(res);
          return;
        }
        this.dialog.closeAll();
        this.router.navigate(['/cart-checkout']);
      },
      error: (err) => {
        this.addingToCart = false;
        const errorBody = err.error;
        const msg = 'Lo sentimos, no se han podido añadir las entradas al carrito. Por favor, inténtalo de nuevo más tarde.';
        if (errorBody && errorBody.message === 'cart_add_failed_rules') {
          // Reglas de compra (tope por persona, nominativas, canal de venta): el
          // servidor cuenta también los pedidos anteriores, así que es el único
          // que sabe explicar por qué no cabe otra entrada. Manda el motivo ya
          // redactado.
          const errMsg = errorBody?.errors?.errors?.[0] || msg;
          this.resetTicketSelection();
          this.showTemporaryError(errMsg);
          this.openInfoCard(errMsg);
        } else if (errorBody && errorBody.message === 'cart_add_failed') {
          this.handleCartError(errorBody);
        } else if(errorBody && errorBody.message === 'cart_add_failed_capacity') {
          const errMsg = "Lo sentimos, no hay suficientes entradas disponibles para añadir al carrito. Por favor, reduce la cantidad de entradas seleccionadas e inténtalo de nuevo.";
          this.showTemporaryError(errMsg);
          this.openInfoCard(errMsg);
        } else {
          this.resetTicketSelection();
          this.showTemporaryError(msg);
          this.openInfoCard(msg);
        }
      }
    })
  }

  private handleCartError(errorBody: any) {
    const msg = 'Lo sentimos, no se han podido añadir las entradas al carrito. Por favor, inténtalo de nuevo más tarde.';
    this.resetTicketSelection();
    this.showTemporaryError(msg);
    this.openInfoCard(msg);
    this.getTicketsEnabled();
  }

  private resetTicketSelection() {
    this.selectTickets = [];
    this.priceTotal = 0;
  }

  closeHoursEmit() {
    this.closeHours.emit(false);
    this.dialogRef?.close();
  }

  confirmSessionSelection() {
    if (!this.selectedDate) {
      this.openInfoCard('Por favor, selecciona una fecha en el calendario');
      return;
    }

    if (this.optionsHours.length > 0 && !this.hourSelected) {
      this.openInfoCard('Por favor, selecciona un horario');
      return;
    }

    if (!this.sessionSelected) {
      this.openInfoCard('No se pudo encontrar la sesión seleccionada');
      return;
    }

    // Cerrar el diálogo con la sesión seleccionada
    this.dialogRef.close({
      session: this.sessionSelected
    });
  }

  showTemporaryError(msg: string) {
    if (this.errorTimeout) clearTimeout(this.errorTimeout);
    this.error = msg;
    this.errorTimeout = setTimeout(() => {
      this.error = null;
    }, 5400);
  }

  openInfoCard(msg: string) {
    this.dialog.open(InfoCardComponent, {
      panelClass: 'info-dialog',
      data: {
        icon: true,
        text: msg,
        btnCancel: false
      }
    });
  }

  /**
   * Oculta el chip de hora cuando, siendo la fecha seleccionada "hoy", ya se ha pasado el límite:
   * - Con end_sales: hasta end_sales + 1h (global) Y además hasta sesión + 1h (ej. sesión 06:00 → hasta 07:00).
   * - Sin end_sales: hasta hora de la sesión + 1 hora (ej. sesión 10:00 visible hasta 10:59).
   */
  shouldHideHourChipForTime(hour: { time: string; sessions: string[]; dates: string[] }, dateString: string): boolean {
    if (!dateString || !hour?.time) {
      return false;
    }
    const today = new Date();
    const todayStr = formatDate(today, 'yyyy-MM-dd', 'es');
    if (dateString !== todayStr) {
      return false;
    }
    const nowMs = Date.now();

    if (this.event?.end_sales) {
      const endSalesMs = new Date(this.event.end_sales).getTime();
      const cutoffGlobalMs = endSalesMs + 60 * 60 * 1000;
      if (nowMs >= cutoffGlobalMs) {
        return true;
      }
    }

    // Sesión de hoy ya empezada que el fin de ventas todavía permite vender:
    // el chip se mantiene.
    const extendedToday = (hour.dates || []).some((sessionDate: string) =>
      String(sessionDate).replace(' ', 'T').startsWith(dateString) &&
      this.eventosService.isSessionSaleExtended(this.event, { start_date: sessionDate })
    );
    if (extendedToday) {
      return false;
    }

    const [h, m] = hour.time.split(':').map(Number);
    const cutoffSessionMs = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      h + 1,
      m ?? 0,
      0,
      0
    ).getTime();
    return nowMs >= cutoffSessionMs;
  }

}
